// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Iaa-z","colorTextValue":"Jaa-z","swatches":"Kaa-z","collapseLink":"Laa-z","isCollapsed":"Maa-z","dropdown":"Naa-z","disabled":"Oaa-z"};